// generated from 6_069 samples

import { z } from "zod";
import { common } from "../common";

export const subscriptionStateChangedTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::SubscriptionStateChanged"),
  // null: 2 (0.03%)
  subscription_state: common
    .numericEnum([
      1, // 3_686 (60.75%)
      2, // 1_464 (24.13%)
      0, // 917 (15.11%)
    ])
    .nullable(),
  // null: 2 (0.03%)
  subscription_type: z
    .enum([
      "email", // 5_006 (82.51%)
      "push", // 1_061 (17.49%)
    ])
    .nullable(),
});
